module.exports = __webpack_public_path__ + "img/google-play-badge.01f941b.svg";